import * as types from '../actions/types';

const initialState = {
    key: {},
    loading: false,
    applicant: [],
    applicant_loading: false,
    studyYears: [],
    edu_program: [],
    faculty: [],
    trainingDirect: [],
    
    pageNumber: 0,
    pageCount: 0,
    count: 0,
};

export default function encryptionKeys(state = initialState, action) {
    switch (action.type) {
        case types.ENCRYPTION_KEYS:
            return {
                ...state,
                key: action.payload
            };
        case types.SET_APPLICANT_PAGES_COUNT:
            return {...state, 
                ...action.payload};
        case types.ENCRYPTION_KEYS_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case types.APPLICANT:
            return {
                ...state,
                applicant: action.payload
            }
        case types.APPLICANT_LOADING:
            return {
                ...state,
                applicant_loading: action.payload
            }
        case types.SET_STUDY_YEAR:
            return {
                ...state,
                studyYears: action.payload
            }
        case types.SET_CATEGORY_APLICANT:
            return {
                ...state,
                edu_program: action.payload
            }
        case types.SET_FACULTY:
            return {
                ...state,
                faculty: action.payload
            }
        case types.SET_TRAINING_DIRECT:
            return {
                ...state,
                trainingDirect: action.payload
            }
        default:
            return state;
    }
}
